/**
 * Floating label functionality for form inputs
 * Handles inputs with and without placeholder attributes
 * Includes accessibility enhancements
 */

function initFloatingLabels() {
  // Detect Firefox
  const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

  // Check for reduced motion preference
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Only target inputs within elements that have the .floating-labels class
  const inputs = document.querySelectorAll('.floating-labels .fui-type-single-line-text .fui-input, .floating-labels .fui-type-email .fui-input');

  inputs.forEach(input => {
    // Add placeholder if it doesn't exist (for CSS functionality)
    if (!input.hasAttribute('placeholder')) {
      input.setAttribute('placeholder', ' ');
    }

    // Add aria-describedby if not present (for screen readers)
    const label = input.closest('.fui-field-container')?.querySelector('.fui-label');
    if (label && !input.hasAttribute('aria-describedby')) {
      const labelId = label.id || `label-${Math.random().toString(36).substr(2, 9)}`;
      if (!label.id) label.id = labelId;
      // Note: We don't add aria-describedby as the label is already associated via 'for' attribute
    }

    // Function to check if input has value and toggle class
    function checkValue() {
      const container = input.closest('.fui-field-container');
      if (container) {
        const hasValue = input.value.trim() !== '';

        if (hasValue) {
          container.classList.add('has-value');
        } else {
          container.classList.remove('has-value');
        }

        // For screen readers: announce state change if reduced motion is enabled
        // (indicating user might rely more on announcements)
        if (prefersReducedMotion && label) {
          const isFloated = hasValue || container.matches(':focus-within');
          label.setAttribute('aria-live', 'polite');
          label.setAttribute('aria-atomic', 'true');

          // Remove aria-live after brief moment to avoid constant announcements
          setTimeout(() => {
            label.removeAttribute('aria-live');
            label.removeAttribute('aria-atomic');
          }, 100);
        }
      }
    }

    // For Firefox, also add a class to disable CSS :has() behavior
    if (isFirefox) {
      const container = input.closest('.fui-field-container');
      if (container) {
        container.classList.add('js-controlled');
      }
    }

    // Check on page load
    checkValue();

    // Check when input value changes
    input.addEventListener('input', checkValue);
    input.addEventListener('change', checkValue);
    input.addEventListener('blur', checkValue);

    // For Firefox, also check on focus to ensure proper state
    if (isFirefox) {
      input.addEventListener('focus', checkValue);
    }
  });
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', initFloatingLabels);

// Also initialize when Alpine is started (in case of dynamic content)
document.addEventListener('alpine:initialized', initFloatingLabels);

export default initFloatingLabels;
